<template>
  <div>
    <b-table v-if="!isLoading" :fields="fields" :items="items" head-variant="light" hover responsive>
      <template v-slot:cell(identifier)="linha">
        {{ linha.item.identifier }}
      </template>
      <template v-slot:cell(vns_name)="linha">
        <p class="m-0 small" v-if="linha.item.vns_name">
                    <span class="font-weight-bold">
                        {{ $t('review_observation.listagem.table.vns') }}:</span> {{ linha.item.vns_name }}
        </p>
        <p class="m-0 small" v-if="linha.item.company_name">
                    <span class="font-weight-bold">
                        {{ $t('review_observation.listagem.table.empresa') }}:</span> {{ linha.item.company_name }}
        </p>
      </template>      
      <template v-slot:cell(updated_at)="linha">
        {{ linha.item.updated_at | formatDate }}
      </template>
      <template v-slot:cell(acoes)="linha">
        <b-btn variant="outline-primary border-0" pill
          title="Editar Resultados"
          @click="$emit('click-reviewObservation', linha.item)">
            <i class="fas fa-edit"/>
        </b-btn>

        <b-btn variant="outline-danger border-0" pill
          title="Cancelar Resultados"
          @click="$emit('cancel-reviewObservation', linha.item)">
            <i class="fas fa-ban"/>
        </b-btn>
      </template>
    </b-table>
    <Loading v-else/>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import moment from "moment";

export default {
  name: "Table",
  components: {
    Loading,
    moment
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    additionalFields: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        {
          key: 'identifier',
          label: this.$t('review_observation.listagem.table.recipiente')
        },
        {
          key: 'vns_name',
          label: this.$t('review_observation.listagem.table.informacoes')
        },
        {
          key: 'patient_name',
          label: this.$t('review_observation.listagem.table.paciente')
        },
        {
          key: 'exames',
          label: this.$t('review_observation.listagem.table.exames')
        },
        {
          key: 'edited_by_user_name',
          label: this.$t('review_observation.listagem.table.usuario_edicao')
        },
        {
          key: 'updated_at',
          label: this.$t('review_observation.listagem.table.ultima_atualizacao')
        },
        {
          key: 'acoes',
          label: this.$t('review_observation.listagem.table.acoes')
        }
      ]
    }
  },
  methods: {
    getLastUpdate(container) {
      let maxOrderDate = null
      let maxReportDate = null
      container.orders.map(order => {
        const received_at = moment(order.received_at)
        const collected_at = moment(order.collected_at)
        const created_at = moment(order.created_at)

        maxOrderDate = this.getMaxDate([maxOrderDate, received_at, collected_at, created_at])
      })
      container.reports.map(report => {
        const processed_at = moment(report.processed_at)
        const created_at = moment(report.created_at)

        maxReportDate = this.getMaxDate([processed_at, created_at])
      })

      return this.getMaxDate([maxOrderDate, maxReportDate])
    },
    getMaxDate(arrayDates) {
      let maxDate = null
      arrayDates.map(date => {
        if (date && date.isValid()) {
          if (!maxDate) {
            maxDate = date
          }
          if (date.diff(maxDate) > 0) {
            maxDate = date
          }
        }
      })
      return maxDate
    }
  },
  mounted() {
    this.fields = [...this.fields, ...this.additionalFields]
  }
}
</script>

<style lang="scss" scoped>
.badge {
  color: #dddfeb;
  padding: 0.40em;

  i {
    font-size: 1.5em;
  }
}

.badge-danger {
  background-color: #ffe1de;
  color: #e74a3b;
}

.badge-success {
  background-color: #d8fbee;
  color: #1cc88a;
}
</style>
